import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from './avatar';

export function UserLink({ 
  username, 
  displayName, 
  profilePhoto, 
  size = "sm", 
  showAvatar = false, 
  className = "",
  onClick 
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    } else {
      navigate(`/profile/${username}`);
    }
  };

  const getInitials = () => {
    if (displayName) {
      return displayName.substring(0, 2).toUpperCase();
    }
    return username.substring(0, 2).toUpperCase();
  };

  const getProfilePhotoUrl = () => {
    if (profilePhoto) {
      return profilePhoto.startsWith('http') 
        ? profilePhoto 
        : `${process.env.REACT_APP_BACKEND_URL}${profilePhoto}`;
    }
    return null;
  };

  const sizeClasses = {
    xs: "text-xs",
    sm: "text-sm", 
    md: "text-base",
    lg: "text-lg"
  };

  const avatarSizes = {
    xs: "h-4 w-4",
    sm: "h-6 w-6", 
    md: "h-8 w-8",
    lg: "h-10 w-10"
  };

  return (
    <span 
      className={`inline-flex items-center gap-1 cursor-pointer hover:text-blue-600 transition-colors ${sizeClasses[size]} ${className}`}
      onClick={handleClick}
      title={`Voir le profil de ${displayName || username}`}
    >
      {showAvatar && (
        <Avatar className={avatarSizes[size]}>
          <AvatarImage src={getProfilePhotoUrl()} alt={username} />
          <AvatarFallback className="text-xs">
            {getInitials()}
          </AvatarFallback>
        </Avatar>
      )}
      <span className="font-medium">@{username}</span>
    </span>
  );
}

// Variant sans avatar pour utilisation inline
export function UserMention({ username, displayName, size = "sm", className = "" }) {
  return (
    <UserLink 
      username={username}
      displayName={displayName}
      size={size}
      showAvatar={false}
      className={`text-blue-600 hover:text-blue-800 hover:underline ${className}`}
    />
  );
}

export default UserLink;